import dedent from "dedent";

import { isMacLike } from "utils/navigator";

export const EMPTY_POLICY_SAMPLE_RESULTS_MSG = dedent`
  # Click "Simulate" button above
  # or press "${isMacLike ? `Cmd ⌘` : "Ctrl"} + Enter",
  # to see the results here`;
